import { useEffect } from "react";

import useOnline from "./useOnline";
import syncAll from "../utils/syncAll";

const usePeriodicSync = (serviceProviderId) => {
  const online = useOnline();

  useEffect(() => {
    let periodicPolling;
    if (serviceProviderId && online) {
      syncAll(serviceProviderId);
      periodicPolling = setInterval(() => syncAll(serviceProviderId), 300000);
    }
    return () => {
      if (periodicPolling !== undefined) {
        clearInterval(periodicPolling);
      }
    };
  }, [serviceProviderId, online]);
};

export default usePeriodicSync;
